"use client"

import React from 'react'
import { Lock } from 'lucide-react'

/**
 * Displays a "Restricted" indicator in place of a PII field that the
 * current user doesn't have access to. Replaces the normal form input
 * with a locked-state badge.
 */
export function RestrictedPiiField({
    label,
    className = '',
}: {
    label: string
    className?: string
}) {
    return (
        <div className={`space-y-0.5 w-full flex flex-col ${className}`}>
            <span className="text-sm font-medium text-foreground">{label}</span>
            <div className="flex items-center gap-2 h-9 min-h-9 px-3 rounded-md border border-input bg-muted/50 text-muted-foreground text-sm">
                <Lock className="h-3.5 w-3.5 shrink-0 text-muted-foreground/70" />
                <span className="text-muted-foreground/80 italic">Restricted</span>
            </div>
        </div>
    )
}
